import { Link, useLocation } from "wouter";
import { useAdminAuth } from "../hooks/use-admin-auth";
import {
  LayoutDashboard,
  Users,
  CreditCard,
  RefreshCw,
  TrendingUp,
  LogOut,
  Shield,
  MessageSquare,
  MessageCircle,
  BookOpen,
  Radar,
  Megaphone,
  Mic,
  Mail,
  FileText,
  FlaskConical,
  KeyRound,
  Handshake,
} from "lucide-react";

const navItems = [
  { path: "/", label: "Дашборд", icon: LayoutDashboard },
  { path: "/users", label: "Пользователи", icon: Users },
  { path: "/payments", label: "Платежи", icon: CreditCard },
  { path: "/recurring", label: "Автоплатежи", icon: RefreshCw },
  { path: "/tickets", label: "Тикеты", icon: MessageSquare },
  { path: "/chats", label: "Чаты AI-сотрудника", icon: MessageCircle },
  { path: "/forecast", label: "Прогноз", icon: TrendingUp },
  { path: "/blog", label: "Блог", icon: BookOpen },
  { path: "/hh-scanner", label: "HH Scanner", icon: Radar },
  { path: "/avito-platform-listings", label: "Avito Listings", icon: Megaphone },
  { path: "/client-transcripts", label: "Транскрипты чатов", icon: Mic },
  { path: "/bot-test", label: "Тест ботов", icon: FlaskConical },
  { path: "/delegation", label: "Делегирование", icon: KeyRound },
  { path: "/partner-applications", label: "Заявки партнёров", icon: Handshake },
  { path: "/daily-reports", label: "Daily Reports", icon: Mail },
  { path: "/audit-logs", label: "Audit Logs", icon: FileText },
];

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const { admin, logout } = useAdminAuth();
  const [location] = useLocation();

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar */}
      <aside className="w-64 border-r border-border bg-sidebar flex flex-col">
        <div className="p-4 border-b border-sidebar-border">
          <div className="flex items-center gap-2">
            <Shield className="w-6 h-6 text-primary" />
            <span className="font-semibold text-lg">GPT Admin</span>
          </div>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => {
            const isActive =
              item.path === "/"
                ? location === "/"
                : location.startsWith(item.path);
            return (
              <Link key={item.path} href={item.path}>
                <div
                  className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium cursor-pointer transition-colors ${
                    isActive
                      ? "bg-sidebar-accent text-sidebar-accent-foreground"
                      : "text-sidebar-foreground hover:bg-sidebar-accent/50"
                  }`}
                >
                  <item.icon className="w-4 h-4" />
                  {item.label}
                </div>
              </Link>
            );
          })}
        </nav>

        <div className="p-3 border-t border-sidebar-border">
          <div className="flex items-center justify-between px-3 py-2">
            <div className="text-sm">
              <div className="font-medium truncate">
                {admin?.firstName || admin?.email}
              </div>
              <div className="text-xs text-muted-foreground">{admin?.role}</div>
            </div>
            <button
              onClick={logout}
              className="p-1.5 rounded hover:bg-sidebar-accent transition-colors"
              title="Выйти"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-6">{children}</div>
      </main>
    </div>
  );
}
